import { call, put, takeLatest } from 'typed-redux-saga'
import { leadApi, leadOneNS, leadOneSlice, RbidosLeadModel } from 'Pages/lead'
import { Deserialize } from 'cerialize'
import { errorHandler, loadersSlice } from 'Modules'
import { takeEveryUnique } from 'Src/helpers'

function* getOne(action: leadOneNS.GetOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(leadApi.getOne, action.payload)
		const lead = Deserialize(res, RbidosLeadModel)
		yield* put(leadOneSlice.actions.setOne(lead))
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* createOne(action: leadOneNS.CreateOne) {
	try {
		const { data, callback } = action.payload
		const res = yield* call(leadApi.createOne, data)
		yield* put(leadOneSlice.actions.setOne(Deserialize(res, RbidosLeadModel)))
		callback?.()
	} catch (error) {
		const { formName, errorCallback } = action.payload
		const errors = error?.data?.errors
		errorCallback?.(errors)
		yield* call(errorHandler, error, formName)
	}
}

export function* leadOneSaga() {
	yield* takeLatest(leadOneSlice.actions.getOne.type, getOne)
	yield* takeEveryUnique(leadOneSlice.actions.createOne.type, createOne)
}
